import { Injectable } from '@angular/core';
import { ConstantsService } from 'src/app/services/constants.service';
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient, HttpContext, HttpHeaders } from "@angular/common/http";
import { BYPASS_JWT_TOKEN } from 'src/app/helpers/jwt.interceptor';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class UnidadesSiipneService {

  constructor(private http: HttpClient,
    private alert: AlertService) { }

  listChilds(parent_id: number): Observable<any> {
    return this.http.get(`${ConstantsService.SIIPNE_UNIDADES_DEPENDIENTES_URL}${parent_id}/detalles`).pipe(
      map((data: any) => {
        let resp = [];
        data.result.forEach(element => {
          resp.push({ label: element.descripcion, data: element.idDgpUnidad, children: [{}] })
        });
        return resp;
      }),
      catchError((err)=> {        
        this.alert.alert("ERROR DE CONEXIÓN CON SIPPNE 3W!", err.message, "error");                                            
        return of(err)
    }), 
    )
  }

  listParents(): any {
    return this.http.get(ConstantsService.SIIPNE_UNIDADES_URL).pipe(
      map((data: any) => {
        let resp = [];
        data.result.forEach(element => {
          resp.push({ label: element.descripcion, data: element.idDgpUnidad })
        });
        return resp;
      }),
      catchError((err)=> {        
        this.alert.alert("ERROR DE CONEXIÓN CON SIPPNE 3W...", err.message, "error");                                            
        return of(err)
    }), 
    )
  }
}
